import { disableKosten } from '../../helpers/showKosten';
import { formatNumber } from '../../core/formatter/formatNumber';
import { IDs } from '../../helpers/IDs';
import { i18n } from '../../i18n/i18n';
import { Image, Text, View } from '@react-pdf/renderer';
import { parsePdfSub2 } from './generisch/helper';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { SectionStyle } from '../../helpers/SectionStyle';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WpdfText } from './pdf/WpdfText.';
import { WpdfView } from './pdf/WpdfView';

interface EnergieCockpitEnergiedatenProps extends React.ClassAttributes<any> {
    data: any;
    dataItems: any[];
    jahr: number;
    onJahrChange: (jahr: number) => void;
    onPdfDataLoaded?: (data: JSX.Element) => void;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface EnergieCockpitEnergiedatenState {
    mouseOverCol: number;
    mouseOverItem: string;
}

export class EnergieCockpitEnergiedaten extends React.Component<EnergieCockpitEnergiedatenProps, EnergieCockpitEnergiedatenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            mouseOverCol: undefined,
            mouseOverItem: undefined
        };
        this.disableKosten = disableKosten(this.props.data);
    }

    private disableKosten: boolean;

    componentDidUpdate(prevProps: any): void {
        if (this.props.dataItems !== prevProps.dataItems) {
            this.getPdfData();
        }
    }

    getPdfData(): void {
        this.props.onPdfDataLoaded(
            <View style={{ border: '1 solid #e9e9e9' }}>
                <View>
                    <View
                        style={{
                            backgroundColor: '#e9e9e9', marginBottom: 7, padding: 2, display: 'flex', flex: 1, flexDirection: 'row',
                            alignItems: 'center'
                        }}
                    >
                        <View style={{ color: 'black', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: '10pt' }}>{i18n('Energiedaten', 'sys')}</Text>
                            <Text style={{ fontSize: '8pt', marginLeft: 2 }}>- {i18n('tabellarisch', 'sys')}</Text>
                        </View>
                    </View>
                    {this.renderContent(true)}
                </View>
            </View>
        );
    }

    getStyle(isPdf?: boolean): any {
        const [backgroundColorSection, colorSection] = new SectionStyle().getPropertyValues([
            '--color-section-main', '--color-button-text'
        ]);
        const width: number = isPdf ? 420 : 640;
        // const width: number = isPdf ? 420 : 630;
        // const width: number = isPdf ? 514 : 630;
        const cols: number = 7 - (this.disableKosten ? 2 : 0);
        const colWidth: number = width / cols;

        return ({
            tabelle: {
                fontSize: isPdf ? '8pt' : '9pt',
                maxWidth: colWidth * cols,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            header: {
                color: colorSection || 'white',
                backgroundColor: backgroundColorSection || '#6d893f',
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                alignItems: 'center',
                boxSizing: 'border-box'
            },
            light: {
                color: 'black',
                backgroundColor: '#f7f7f7',
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                alignItems: 'center',
                boxSizing: 'border-box'
            },
            dark: {
                color: 'black',
                backgroundColor: '#f7f7f7',
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                alignItems: 'center',
                boxSizing: 'border-box'
            },
            row: {
                height: isPdf ? 18 : 30,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                boxSizing: 'border-box'
            },
            row_buttons: {
                 marginTop: -30,
                 marginLeft: '100%',
                 alignItems: 'center',
                 alignSelf: 'flex-start',
                 zIndex: 1
            },
            col1: {
                width: colWidth,
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            col2: {
                width: colWidth * 2,
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            bold: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontWeight: 'bold'
            },
            button: {
                fontSize: '10pt',
                color: '#888',
                margin: 0,
                marginLeft: 2,
                padding: 0,
                border: '1px solid #888'
            },
            button_msg: {
                fontSize: '12pt',
                backgroundColor: 'transparent',
                margin: 0,
                marginLeft: 5,
                padding: 0,
                border: '1px solid transparent'
            }
        });
    }

    render(): JSX.Element {
        return (
            <div
                style={{
                    borderTopRightRadius: 'var(--border-radius-headline)', borderTopLeftRadius: 'var(--border-radius-headline)',
                    boxShadow: 'var(--assistent-box-shadow)', display: 'flex', flexDirection: 'column'
                }}
            >
                <div
                    style={{
                        fontWeight: 600, fontSize: 'var(--font-size-headline)', backgroundColor: 'var(--color-bg-headline)',
                        maxHeight: 'var(--height-headline)', minHeight: 'var(--height-headline)', padding: '0 10px 0 20px',
                        borderTopRightRadius: 'var(--border-radius-headline)', borderTopLeftRadius: 'var(--border-radius-headline)',
                        display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'
                    }}
                >
                    {this.renderTitel()}
                </div>
                <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    renderButtons(item: any): JSX.Element {
        const flags: any = ((this.props.data || {})[IDs.KENNZIFFERN_BERECHNET] || {}).flags || {};
        const name: string = item.name || null;
        const styles: any = this.getStyle();
        const hasAuswertung: boolean = (
            (name === i18n('Kraftstoffe', 'sys') && flags.hasKraftstoffe)
            || (name === i18n('Strom', 'sys') && flags.hasStrom)
            || (name === i18n('Wärme', 'sys') && flags.hasWaerme)
        );
        const isGefuehrterModus: boolean = (this.props.data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.gefuehrter_modus_orig === 1);

        return (
            <div style={{ ...styles.row, ...styles.row_buttons }}>
                {!isGefuehrterModus &&
                    <WActionButton
                        label={i18n('Dateneingabe', 'sys')}
                        tooltip={i18n('Zum Dateneingabebereich springen', 'sys')}
                        key='dateneingabe'
                        action='edit'
                        style='small'
                        styleProps={styles.button}
                        onAction={() => this.props.onRoutingChange(this.setRouting(item, 'eingabe'))}
                    />
                }
                {hasAuswertung &&
                    <WActionButton
                        label={i18n('Auswertung', 'sys')}
                        tooltip={i18n('Zum Datenauswertungsbereich springen', 'sys')}
                        key='auswertung'
                        action='view'
                        style='small'
                        styleProps={styles.button}
                        onAction={() => this.props.onRoutingChange(this.setRouting(item, 'auswertung'))}
                    />
                }
            </div>
        );
    }

    renderContent(isPdf?: boolean): JSX.Element {
        const items: any[] = this.props.dataItems || null;
        const styles: any = this.getStyle(isPdf);

        return (
            <WpdfView style={styles.tabelle} pdf={isPdf}>
                {this.renderContentHeader(isPdf)}
                {items &&
                    items.map((item: any, index: number) =>
                        <React.Fragment key={`item-${index}`}>{this.renderRow(item, index, isPdf)}</React.Fragment>
                    )
                }
            </WpdfView>
        );
    }

    renderContentHeader(isPdf?: boolean): JSX.Element {
        const color: string = new SectionStyle().getPropertyValue('--color-section-main') || '#6d893f';
        const jahr = this.props.jahr;
        const vorjahr: string = i18n('Vorjahr', 'sys');
        const styles: any = this.getStyle(isPdf);
        const height: number = parseInt((styles.row || {}).height || 0) * 2;

        return <>
            <WpdfView style={{ ...styles.row, ...styles.bold }} pdf={isPdf}>
                <WpdfView style={{ ...styles.header, ...styles.col1, height, borderTop: 0, borderLeft: 0 }} pdf={isPdf}>
                    {this.renderFieldHeader(i18n('Energieträger', 'sys'), isPdf)}
                </WpdfView>
                <WpdfView style={{ ...styles.header, ...styles.col2, borderTop: 0 }} pdf={isPdf}>
                    {this.renderFieldHeader(`${i18n('Verbrauch', 'sys')} [kWh]`, isPdf)}
                </WpdfView>
                {!this.disableKosten &&
                    <WpdfView style={{ ...styles.header, ...styles.col2, borderTop: 0 }} pdf={isPdf}>
                        {this.renderFieldHeader(`${i18n('Kosten', 'sys')} [€]`, isPdf)}
                    </WpdfView>
                }
                <WpdfView style={{ ...styles.header, ...styles.col2, borderTop: 0 }} pdf={isPdf}>
                    {this.renderFieldHeader('CO₂ [t]', isPdf)}
                </WpdfView>
            </WpdfView>
            <WpdfView style={styles.row} pdf={isPdf}>
                <WpdfView
                    style={{
                        ...styles.header, ...styles.col1, height: 0, borderTopColor: color, borderLeft: 0, alignSelf: 'flex-end'
                    }}
                    pdf={isPdf}
                />
                {[1, ...(!this.disableKosten ? [2] : []), 3].map((index: number) =>
                    <React.Fragment key={`col-${index}`}>
                        <WpdfView style={{ ...styles.header, ...styles.col1 }} pdf={isPdf}>
                            {this.renderFieldHeader(jahr, isPdf)}
                        </WpdfView>
                        <WpdfView style={{ ...styles.header, ...styles.col1 }} pdf={isPdf}>
                            {this.renderFieldHeader(vorjahr, isPdf)}
                        </WpdfView>
                    </React.Fragment>
                )}
            </WpdfView>
        </>;
    }

    renderField(
        style: any, value: number, arrow: JSX.Element, index: number, showButtons: boolean, item: any, isPdf?: boolean, msg?: string
    ): JSX.Element {
        const formattedValue = index > 4 ? formatNumber(+value, 2) : formatNumber(+value, 0);
        const styles: any = this.getStyle(isPdf);
        const msg_tooltip = msg ? this.renderMsgButton(msg, style.color) : '';

        return (isPdf
            ? <View style={{ ...style, display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <View>
                    <Text>{formattedValue}</Text>
                </View>
                {arrow || null}
            </View>
            : <div
                style={{ ...style, cursor: showButtons && 'pointer' }}
                onMouseEnter={() => this.setState({ mouseOverItem: item.name, mouseOverCol: index })}
                onMouseLeave={() => this.setState({ mouseOverItem: undefined, mouseOverCol: undefined })}
            >
                <div style={{ ...styles.row, alignItems: 'center' }}>
                    {formattedValue} {arrow || null} {msg_tooltip}
                </div>
                {showButtons && (this.state.mouseOverItem || null) === item.name && this.state.mouseOverCol === index &&
                    this.renderButtons(item)
                }
            </div>
        );
    }

    renderFieldHeader(text: number | string, isPdf?: boolean): JSX.Element {
        const styles: any = this.getStyle(isPdf);

        return (isPdf
            ? <View style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <Text>{parsePdfSub2(text, styles.tabelle)}</Text>
            </View>
            : <div style={{ margin: 'auto' }}>
                {text}
            </div>
        );
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label={i18n('Energie Cockpit - Energiedaten', 'sys')}
                helpKey='energie_cockpit_energiedaten'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderMsgButton(msg: string, color: string): JSX.Element {
        const styles: any = this.getStyle();

        return (
            <WActionButton
                label={msg}
                tooltip={msg}
                key='msg'
                action='none'
                insideText='*'
                insideLeftMargin={0}
                style='small'
                styleProps={{ ...styles.button_msg, color }}
                onAction={null}
            />
        );
    }

    renderRow(item: any, index: number, isPdf?: boolean): JSX.Element {
        const isValue = (value: any): boolean => typeof value === 'number' && !isNaN(value);
        const srcFallend: string = require('../../icons/desc-green.png');
        const srcSteigend: string = require('../../icons/asc-red.png');
        const styles: any = this.getStyle(isPdf);
        // const fallend = <img src={srcFallend} height={8} alt='↘' />;
        // const steigend = <img src={srcSteigend} height={8} alt='↗' />;
        const fallend = isPdf
            ? <Image src={srcFallend} style={{ width: 6, height: 6, marginLeft: 3 }} />
            : <img src={srcFallend} style={{ marginLeft: 3 }} height={8} alt='↘' />;
        const steigend = isPdf
            ? <Image src={srcSteigend} style={{ width: 6, height: 6, marginLeft: 3 }} />
            : <img src={srcSteigend} style={{ marginLeft: 3 }} height={8} alt='↗' />;
        // ↘: &#8600;, ↗: &#8599;
        const arrow_v = (!isValue(item.v_vorjahr) || !isValue(item.v_jahr) || +item.v_jahr === +item.v_vorjahr)
            ? null
            : (item.v_jahr > item.v_vorjahr ? steigend : fallend);
        const arrow_k = (!isValue(item.k_vorjahr) || !isValue(item.k_jahr) || +item.k_jahr === +item.k_vorjahr)
            ? null
            : (item.k_jahr > item.k_vorjahr ? steigend : fallend);
        const arrow_c = (!isValue(item.c_vorjahr) || !isValue(item.c_jahr) || +item.c_jahr === +item.c_vorjahr)
            ? null
            : (item.c_jahr > item.c_vorjahr ? steigend : fallend);
        const showButtons = index < 3;
        styles.col1 = (index === 0 || index === 3)
            ? { ...styles.col1, ...(index === 3 && styles.bold), ...(isPdf && { borderTopWidth: '2pt' }) }
            : styles.col1;

        return (
            <WpdfView
                key={`item-row-${index}`}
                style={{ ...styles.row/*, ...((!isPdf && (index === 0 || index === 3)) && { marginTop: 1 })*/ }}
                pdf={isPdf}
            >
                {isPdf &&
                    <View style={{ ...styles.header, ...styles.col1, borderLeft: 0 }}>
                        {this.renderFieldHeader(item.name, isPdf)}
                    </View>
                }
                {!isPdf &&
                    <div
                        style={{ ...styles.header, ...styles.col1, borderLeft: 0, alignItems: 'center', cursor: showButtons && 'pointer' }}
                        onMouseEnter={() => this.setState({ mouseOverItem: item.name, mouseOverCol: 0 })}
                        onMouseLeave={() => this.setState({ mouseOverItem: undefined, mouseOverCol: undefined })}
                    >
                        <div style={{ ...styles.row, alignItems: 'center' }}>{item.name}</div>
                        {showButtons && (this.state.mouseOverItem || null) === item.name && this.state.mouseOverCol === 0 &&
                            this.renderButtons(item)
                        }
                    </div>
                }
                {this.renderField({ ...styles.light, ...styles.col1 }, item.v_jahr, arrow_v, 1, showButtons, item, isPdf, item.msg_jahr)}
                {this.renderField({ ...styles.dark, ...styles.col1 }, item.v_vorjahr, undefined, 2, showButtons, item, isPdf, item.msg_vorjahr)}
                {!this.disableKosten && <>
                    {this.renderField({ ...styles.light, ...styles.col1 }, item.k_jahr, arrow_k, 3, showButtons, item, isPdf)}
                    {this.renderField({ ...styles.dark, ...styles.col1 }, item.k_vorjahr, undefined, 4, showButtons, item, isPdf)}
                </>}
                {this.renderField({ ...styles.light, ...styles.col1 }, item.c_jahr, arrow_c, 5, showButtons, item, isPdf)}
                {this.renderField({ ...styles.dark, ...styles.col1 }, item.c_vorjahr, undefined, 6, showButtons, item, isPdf)}
            </WpdfView>
        );
    }

    renderTitel(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {i18n('Energiedaten', 'sys')}<span style={{ fontSize: 'small', marginRight: 5, marginLeft: 3 }}>- {i18n('tabellarisch', 'sys')}</span>{this.renderHelpIcon()}
            </div>
        );
    }

    setRouting(item: any, bereich: string): any {
        const name: string = item.name || null;
        let route: any = {};

        if (bereich === 'auswertung') {
            const tabStandort: any = { [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: 1 };

            switch (name) {
                case i18n('Kraftstoffe', 'sys'):
                    route = { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_KRAFTSTOFFE, ...tabStandort }};
                    break;
                case i18n('Strom', 'sys'):
                    route = { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM, ...tabStandort }};
                    break;
                case i18n('Wärme', 'sys'):
                    route = { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME, ...tabStandort }};
                    break;
            }
        } else if (bereich === 'eingabe') {
            const path: any = {
                ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX,
                [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX]: 0,
                terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX
            };

            switch (name) {
                case i18n('Kraftstoffe', 'sys'):
                    route = { path, entities: [ IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE ] }
                    break;
                case i18n('Strom', 'sys'):
                    route = { path, entities: [ IDs.ENT_ENERGIEDATEN_STROM ] }
                    break;
                case i18n('Wärme', 'sys'):
                    route = { path, entities: [ IDs.ENT_ENERGIEDATEN_WAERME ] }
                    break;
            }
        }

        return route;
    }
}
